
document.addEventListener('DOMContentLoaded', function () {
  const menu=document.querySelector('.mobile-menu');
  const nav=document.querySelector('.nav-links');
  if(menu&&nav){
    menu.addEventListener('click',function(){
      nav.style.display=nav.style.display==='flex'?'none':'flex';
      nav.style.position='absolute'; nav.style.top='68px'; nav.style.left='0'; nav.style.right='0';
      nav.style.background='#fff'; nav.style.padding='18px'; nav.style.flexDirection='column';
    });
  }

  // Copy-to-clipboard buttons (e.g. Contact page "Copy email")
  document.querySelectorAll('[data-copy]').forEach(function(btn){
    btn.addEventListener('click',function(){
      const value=btn.getAttribute('data-copy');
      if(!value) return;
      navigator.clipboard.writeText(value).then(function(){
        const original=btn.textContent;
        btn.textContent='Copied!';
        setTimeout(function(){ btn.textContent=original; },1800);
      });
    });
  });
});
